/* color-codemod: skip — color generation utility. The hex values define the palette used by the deterministic per-user avatar color hash function. */
const AVATAR_COLORS = [
  '#4F46E5', // indigo
  '#7C3AED', // violet
  '#2563EB', // blue
  '#0E7490', // cyan-700 (AA-compliant at small sizes)
  '#047857', // emerald-700 (AA-compliant at small sizes)
  '#DC2626', // red
  '#D97706', // amber
];

export function generateInitialsAvatar(name: string | undefined, size = 40): string {
  const text = (name ?? '').trim();
  const initials = text
    .split(/\s+/)
    .slice(0, 2)
    .map(word => /^[A-Za-z\d]/.test(word[0] ?? '') ? word[0].toUpperCase() : '?')
    .join('') || '?';

  const colorIndex = text.length > 0 ? text.charCodeAt(0) % AVATAR_COLORS.length : 0;
  const color = AVATAR_COLORS[colorIndex];
  const fontSize = Math.round(size * 0.4);

  const svg = [
    `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">`,
    `<circle cx="${size / 2}" cy="${size / 2}" r="${size / 2}" fill="${color}"/>`,
    `<text x="50%" y="50%" dy=".35em" text-anchor="middle" fill="white"`,
    ` font-size="${fontSize}" font-family="system-ui,sans-serif" font-weight="600">${initials}</text>`,
    `</svg>`,
  ].join('');

  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

export function getInitials(name?: string): string {
  if (!name) return 'U';
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map(n => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

interface ProfilePictureLike {
  processedUrls?: { thumbnail?: string; small?: string };
  originalUrl?: string;
}

export function getAvatarUrl(profilePicture?: unknown): string | null {
  if (!profilePicture || typeof profilePicture !== 'object') return null;
  const pp = profilePicture as ProfilePictureLike;
  return pp.processedUrls?.thumbnail
    ?? pp.processedUrls?.small
    ?? pp.originalUrl
    ?? null;
}
